<template>
	<transition name="fade">
		<div class="modal" v-if="visible">
			<div class="modal-back" @click="close"></div>
			<div class="modal-front">
				<div class="modal-header" ref="header">
					<slot name="header"></slot>
					<transition name="fade">
						<div class="close-btn" v-if="!disabled">
							<icon icon="essentials/basics/close-circle" @click="close"></icon>
						</div>
					</transition>
				</div>
				<div class="modal-body" ref="body" :style="{'max-height': height + 'px'}">
					<slot></slot>
				</div>
				<div class="modal-footer" ref="footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		props: ['value', 'disabled'],
		data() {
			return {
				visible: this.value,
				height: 0
			};
		},
		watch: {
			value: {
				handler() {
					this.visible = this.value;
					this.$emit('input', this.value);
				},
				deep: true
				
			},
			visible: {
				handler() {
					this.$emit('input', this.visible);
					this.$nextTick(() => {
						this.handleResize();
					});
				},
				deep: true
			}
		},
		methods: {
			close() {
				if(this.disabled) {
					return;
				}
				this.visible = false; 
				this.$emit('close');
			},
			handleResize(){
				if(this.$refs.header && this.$refs.footer){
					var header = this.$refs.header.getBoundingClientRect();
					var footer = this.$refs.footer.getBoundingClientRect();
					var height = window.innerHeight - header.height - footer.height;
					if(window.innerWidth > 625){
						height -= 30;
					}
					this.height = height;

				}
			}
		},
		updated(){
			this.handleResize();
		},
		created(){
			window.addEventListener('resize', this.handleResize);
		},
		destroyed() {
			window.removeEventListener('resize', this.handleResize);
		}
	}
</script>